import React from 'react'
import { I18n } from 'react-redux-i18n'

import ModalWrapper from 'components/ModalWrapper'
import PhoneViewer from 'components/PhoneViewer'

const SignaturePreviewModalUI = ({ isOpen, toggle, channel, template }) => (
  <ModalWrapper
    isOpen={isOpen}
    toggle={toggle}
    header={I18n.t('dashboard_preview')}
    body={
      <div className='modal-content'>
        <PhoneViewer
          textPreview={template}
          channel={channel}
          previewMsg
        />
      </div>
    }
    eventBtnTxt={I18n.t('dashboard_close')}
    eventBtn={toggle}
    contentClassName='modal-content-phone-preview'
  />
)

export { SignaturePreviewModalUI }
